var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoonboarding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 337 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#D\xE9grad\xE9_sans_nom_30);}.cls-2{fill:url(#D\xE9grad\xE9_sans_nom_30-2);}.cls-3{fill:url(#D\xE9grad\xE9_sans_nom_30-3);}.cls-4{fill:url(#D\xE9grad\xE9_sans_nom_30-4);}.cls-5{stroke-miterlimit:10;fill:url(#D\xE9grad\xE9_sans_nom_33);stroke:url(#D\xE9grad\xE9_sans_nom_33-2);}.cls-6{fill:url(#D\xE9grad\xE9_sans_nom_30-5);}.cls-7{fill:url(#D\xE9grad\xE9_sans_nom_30-6);}.cls-8{fill:url(#D\xE9grad\xE9_sans_nom_30-7);}.cls-9{fill:url(#D\xE9grad\xE9_sans_nom_33-3);}.cls-10{fill:url(#D\xE9grad\xE9_sans_nom_33-4);}.cls-11{fill:url(#D\xE9grad\xE9_sans_nom_33-5);}.cls-12{fill:url(#D\xE9grad\xE9_sans_nom_33-6);}.cls-13{fill:url(#D\xE9grad\xE9_sans_nom_33-7);}.cls-14{fill:url(#D\xE9grad\xE9_sans_nom_33-8);}.cls-15{fill:url(#D\xE9grad\xE9_sans_nom_33-9);}.cls-16{fill:url(#D\xE9grad\xE9_sans_nom_33-10);}.cls-17{fill:url(#D\xE9grad\xE9_sans_nom_33-11);}.cls-18{fill:url(#D\xE9grad\xE9_sans_nom_33-12);}.cls-19{fill:url(#D\xE9grad\xE9_sans_nom_33-13);}.cls-20{fill:url(#D\xE9grad\xE9_sans_nom_33-14);}.cls-21{fill:url(#D\xE9grad\xE9_sans_nom_33-15);}.cls-22{fill:url(#D\xE9grad\xE9_sans_nom_33-16);}.cls-23{fill:url(#D\xE9grad\xE9_sans_nom_33-17);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30",
    x1: 24.96,
    y1: 46.74,
    x2: 101.36,
    y2: 46.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#16f7b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21bbee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-2",
    x1: 258.58,
    y1: 192.5,
    x2: 273.58,
    y2: 192.5,
    gradientTransform: "matrix(0.95, -0.32, 0.32, 0.95, -306.67, -18.71)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-3",
    x1: 51.58,
    y1: 51.37,
    x2: 73.09,
    y2: 51.37,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-4",
    x1: 32.41,
    y1: 47.36,
    x2: 92.66,
    y2: 47.36,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33",
    x1: 18.98,
    y1: 47.89,
    x2: 105.16,
    y2: 47.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c2057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17243e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-2",
    x1: 18.48,
    y1: 47.8,
    x2: 105.66,
    y2: 47.8,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-5",
    x1: 104.99,
    y1: 25.28,
    x2: 111.74,
    y2: 25.28,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-6",
    x1: 114.9,
    y1: 12.74,
    x2: 126.18,
    y2: 12.74,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30-7",
    x1: 275.56,
    y1: 183.07,
    x2: 283.65,
    y2: 183.07,
    gradientTransform: "matrix(0.95, -0.32, 0.32, 0.95, -306.67, -18.71)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-3",
    x1: 0.52,
    y1: 54.81,
    x2: 12.22,
    y2: 54.81,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-4",
    x1: 98.84,
    y1: 6.23,
    x2: 111.27,
    y2: 6.23,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-5",
    x1: 110.67,
    y1: 50.87,
    x2: 134.48,
    y2: 50.87,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-6",
    x1: 137.19,
    y1: 51.19,
    x2: 144.28,
    y2: 51.19,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-7",
    x1: 146.46,
    y1: 54.98,
    x2: 161.38,
    y2: 54.98,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-8",
    x1: 164.17,
    y1: 51.19,
    x2: 171.26,
    y2: 51.19,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-9",
    x1: 174.08,
    y1: 54.98,
    x2: 190.36,
    y2: 54.98,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-10",
    x1: 192.81,
    y1: 54.75,
    x2: 210.55,
    y2: 54.75,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-11",
    x1: 213.87,
    y1: 54.98,
    x2: 228.79,
    y2: 54.98,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-12",
    x1: 232.33,
    y1: 50.64,
    x2: 253.28,
    y2: 50.64,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-13",
    x1: 256.67,
    y1: 54.98,
    x2: 273.32,
    y2: 54.98,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-14",
    x1: 275.66,
    y1: 50.22,
    x2: 281.73,
    y2: 50.22,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-15",
    x1: 284.93,
    y1: 54.98,
    x2: 301.58,
    y2: 54.98,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-16",
    x1: 302.98,
    y1: 54.98,
    x2: 318.65,
    y2: 54.98,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_33-17",
    x1: 320.35,
    y1: 59.06,
    x2: 337,
    y2: 59.06,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_33"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90,85H36.29A11.35,11.35,0,0,1,25,73.65V19.84A11.36,11.36,0,0,1,36.29,8.48H90a11.37,11.37,0,0,1,11.34,11.36V73.65A11.36,11.36,0,0,1,90,85ZM36.29,10.27a9.57,9.57,0,0,0-9.55,9.57V73.65a9.57,9.57,0,0,0,9.55,9.56H90a9.57,9.57,0,0,0,9.56-9.56V19.84A9.57,9.57,0,0,0,90,10.27Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 7.5,
    cy: 76.95,
    rx: 7.5,
    ry: 7.51
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "62.84 63.14 73.09 39.6 51.58 39.6 62.01 63.14 62.84 63.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M62.54,17.19A30.18,30.18,0,1,0,92.66,47.36,30.15,30.15,0,0,0,62.54,17.19Zm3.7,51.19H58.56L43.37,34.79l-.09-.27H81.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M105.15,48.45c.18-4.4-6.63-7.48-12.48-9.32.19.74.34,1.47.47,2.22,4.42,1.47,7.54,3.14,9,4.77a3.21,3.21,0,0,1,1,2.25c-.09,2.29-4,4.55-10.59,6.2-7.38,1.84-18.18,2.91-30.95,2.4S38.21,54.55,31,52.13c-6.48-2.17-10.16-4.73-10.07-7s4-4.55,10.6-6.19c.18-.74.39-1.45.63-2.17-6,1.36-13,3.89-13.17,8.29a5.08,5.08,0,0,0,1.54,3.63c2.32,2.52,6.86,4.4,10.93,5.68l.24.07c8,2.46,18.57,4.05,29.9,4.51s22-.31,30.16-2.13l.23-.06c4.16-.94,8.84-2.46,11.35-4.79A5,5,0,0,0,105.15,48.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M111.74,25.28a3.38,3.38,0,1,1-3.37-3.38A3.38,3.38,0,0,1,111.74,25.28Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 120.54,
    cy: 12.74,
    rx: 5.64,
    ry: 5.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M21.06,62.33a4,4,0,1,1-5.14-2.52A4.05,4.05,0,0,1,21.06,62.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M4.36,49h0A6.2,6.2,0,0,1,.52,56.82h0a6.18,6.18,0,0,1,7.86,3.85h0a6.21,6.21,0,0,1,3.84-7.88h0A6.18,6.18,0,0,1,4.36,49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M105.06,0h0a6.22,6.22,0,0,1-6.21,6.23h0a6.21,6.21,0,0,1,6.21,6.22h0a6.21,6.21,0,0,1,6.21-6.22h0A6.22,6.22,0,0,1,105.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M120,63.77a4.6,4.6,0,0,1-1.8-1.79,14.46,14.46,0,0,1-1.42-3.49l-6.1-21.06H116l5.77,21c.17.66.45,1,.82,1s.66-.32.83-1l5.77-21h5.31l-6.1,21.06A14.46,14.46,0,0,1,127,62a4.6,4.6,0,0,1-1.8,1.79,5.74,5.74,0,0,1-2.59.53A5.67,5.67,0,0,1,120,63.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M138,42.9a2.73,2.73,0,0,1-.83-2,2.77,2.77,0,0,1,.83-2,2.82,2.82,0,1,1,0,4Zm.3,19.15a6.9,6.9,0,0,1-.75-3.52V46.11h4.9V58.38a3.19,3.19,0,0,0,.39,1.66,5.68,5.68,0,0,0,1.42,1.39L141,64.3A6.36,6.36,0,0,1,138.32,62.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M150.23,63.9a5.73,5.73,0,0,1-2.11-1.07A11.2,11.2,0,0,1,146.46,61l3-2.6a6.9,6.9,0,0,0,1.83,1.67,4.74,4.74,0,0,0,2.32.48,5.25,5.25,0,0,0,2.35-.4,1.33,1.33,0,0,0,.74-1.26,1.41,1.41,0,0,0-.92-1.29,15.53,15.53,0,0,0-3.6-.9q-5.28-1-5.28-5.74a4.57,4.57,0,0,1,1.92-3.85A8.43,8.43,0,0,1,154,45.66a9.8,9.8,0,0,1,4.24.77,6.48,6.48,0,0,1,2.54,2.25l-3,2.56A7.69,7.69,0,0,0,156,49.85a4.19,4.19,0,0,0-2-.42c-1.61,0-2.41.57-2.41,1.7a1.31,1.31,0,0,0,.81,1.21,7.63,7.63,0,0,0,2,.64,26.24,26.24,0,0,1,3.71,1.07,5.51,5.51,0,0,1,2.3,1.72,5,5,0,0,1,.92,3.21,4.52,4.52,0,0,1-1.92,4,10.4,10.4,0,0,1-5.8,1.3A12,12,0,0,1,150.23,63.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M165,42.9a2.73,2.73,0,0,1-.83-2,2.77,2.77,0,0,1,.83-2,2.71,2.71,0,0,1,2-.85,2.89,2.89,0,0,1,2.82,2.83,2.82,2.82,0,0,1-4.82,2Zm.3,19.15a6.9,6.9,0,0,1-.75-3.52V46.11h4.9V58.38a3.19,3.19,0,0,0,.39,1.66,5.68,5.68,0,0,0,1.42,1.39L168,64.3A6.3,6.3,0,0,1,165.3,62.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M176.19,62.49a6.46,6.46,0,0,1-2.11-5.17V52.64a6.46,6.46,0,0,1,2.11-5.17,10.95,10.95,0,0,1,12.06,0,6.43,6.43,0,0,1,2.11,5.17v4.68a6.43,6.43,0,0,1-2.11,5.17,10.95,10.95,0,0,1-12.06,0Zm8.42-2.79a3.18,3.18,0,0,0,.85-2.38V52.64a3.18,3.18,0,0,0-.85-2.38,3.86,3.86,0,0,0-4.78,0,3.18,3.18,0,0,0-.85,2.38v4.68a3.18,3.18,0,0,0,.85,2.38,3.86,3.86,0,0,0,4.78,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M209,47.24a6.2,6.2,0,0,1,1.56,4.53V63.85h-4.89V52.22a2.89,2.89,0,0,0-.7-2,2.41,2.41,0,0,0-1.87-.76c-1.65,0-2.85,1-3.58,3V63.85h-4.89V51.58a3.16,3.16,0,0,0-.4-1.66,5.44,5.44,0,0,0-1.41-1.39l3.28-2.87a7.74,7.74,0,0,1,1.9,1.28,4.69,4.69,0,0,1,1.07,1.59,6.15,6.15,0,0,1,2.13-2.08,6.43,6.43,0,0,1,3.34-.79A6,6,0,0,1,209,47.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M217.64,63.9a5.73,5.73,0,0,1-2.11-1.07A11.2,11.2,0,0,1,213.87,61l3-2.6a6.61,6.61,0,0,0,1.83,1.67,4.72,4.72,0,0,0,2.32.48,5.25,5.25,0,0,0,2.35-.4,1.33,1.33,0,0,0,.74-1.26,1.4,1.4,0,0,0-.93-1.29,15.24,15.24,0,0,0-3.6-.9q-5.26-1-5.27-5.74a4.57,4.57,0,0,1,1.92-3.85,8.41,8.41,0,0,1,5.13-1.43,9.72,9.72,0,0,1,4.23.77,6.51,6.51,0,0,1,2.55,2.25l-3,2.56a7.47,7.47,0,0,0-1.77-1.39,4.19,4.19,0,0,0-2-.42c-1.61,0-2.42.57-2.42,1.7a1.31,1.31,0,0,0,.81,1.21,7.71,7.71,0,0,0,2.06.64,26.65,26.65,0,0,1,3.71,1.07,5.51,5.51,0,0,1,2.3,1.72,5.08,5.08,0,0,1,.92,3.21,4.52,4.52,0,0,1-1.92,4,10.42,10.42,0,0,1-5.8,1.3A12,12,0,0,1,217.64,63.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M235.08,61.81c-1.83-1.63-2.75-4-2.75-7.17v-8q0-4.76,2.73-7.17c1.82-1.61,4.51-2.41,8.05-2.41a14.55,14.55,0,0,1,5.76,1,9.42,9.42,0,0,1,3.92,3.09l-2.64,2a8.28,8.28,0,0,0-3-2.47,9.47,9.47,0,0,0-4.13-.81q-7.15,0-7.16,6.75v8q0,6.8,7.16,6.79A9,9,0,0,0,248,60.26,3.68,3.68,0,0,0,249.78,57V55a3.17,3.17,0,0,0-.78-2.31,3.05,3.05,0,0,0-2.27-.79h-4.45V49.09h5.35a5.88,5.88,0,0,1,4.26,1.36,5.56,5.56,0,0,1,1.39,4.15v2.64a5.9,5.9,0,0,1-2.77,5.14A13.17,13.17,0,0,1,243,64.26C239.57,64.26,236.92,63.45,235.08,61.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M272.23,61.19a4.3,4.3,0,0,0,1.09,1.11l-2.22,2a4.09,4.09,0,0,1-2.33-2.79,6.22,6.22,0,0,1-2.51,2,8.56,8.56,0,0,1-3.67.75,6.42,6.42,0,0,1-4.37-1.34,4.84,4.84,0,0,1-1.55-3.87,4.43,4.43,0,0,1,1.81-3.88,10.34,10.34,0,0,1,5-1.62l2.57-.31a4.74,4.74,0,0,0,2.13-.58,1.61,1.61,0,0,0,.47-1.38,3.42,3.42,0,0,0-1.19-2.34,4.81,4.81,0,0,0-3.15-.87,6.14,6.14,0,0,0-2.63.51,5.65,5.65,0,0,0-2,1.64l-2.26-1.62A5.91,5.91,0,0,1,260,46.43a10.67,10.67,0,0,1,4.27-.73c2.54,0,4.45.52,5.73,1.58a5.63,5.63,0,0,1,1.92,4.6v8A2.57,2.57,0,0,0,272.23,61.19Zm-5-.63a4,4,0,0,0,1.45-3.17V54.87a6.87,6.87,0,0,1-2.67.64l-2.22.22c-2.62.31-3.92,1.38-3.92,3.21a2.59,2.59,0,0,0,.9,2.13,4.09,4.09,0,0,0,2.64.74A5.65,5.65,0,0,0,267.2,60.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M277.6,62.55a5.51,5.51,0,0,1-.54-2.67V40.56a2.45,2.45,0,0,0-.31-1.3,4.14,4.14,0,0,0-1.09-1.11l2.19-2a4.75,4.75,0,0,1,2,1.71,5.47,5.47,0,0,1,.54,2.66V59.88a2.79,2.79,0,0,0,.28,1.31,3.93,3.93,0,0,0,1.08,1.11l-2.19,2A4.74,4.74,0,0,1,277.6,62.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M300.49,61.19a4.3,4.3,0,0,0,1.09,1.11l-2.22,2A4.09,4.09,0,0,1,297,61.47a6.22,6.22,0,0,1-2.51,2,8.56,8.56,0,0,1-3.67.75,6.4,6.4,0,0,1-4.37-1.34,4.81,4.81,0,0,1-1.55-3.87,4.43,4.43,0,0,1,1.81-3.88,10.3,10.3,0,0,1,5-1.62l2.56-.31a4.74,4.74,0,0,0,2.13-.58,1.56,1.56,0,0,0,.47-1.38,3.37,3.37,0,0,0-1.18-2.34,4.81,4.81,0,0,0-3.15-.87,6.22,6.22,0,0,0-2.64.51,5.7,5.7,0,0,0-2,1.64l-2.26-1.62a5.88,5.88,0,0,1,2.61-2.17,10.76,10.76,0,0,1,4.28-.73c2.54,0,4.45.52,5.73,1.58a5.63,5.63,0,0,1,1.92,4.6v8A2.57,2.57,0,0,0,300.49,61.19Zm-5-.63a4,4,0,0,0,1.45-3.17V54.87a6.92,6.92,0,0,1-2.67.64l-2.23.22q-3.92.47-3.91,3.21a2.59,2.59,0,0,0,.9,2.13,4.09,4.09,0,0,0,2.64.74A5.67,5.67,0,0,0,295.46,60.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M315.26,63.85l-4.52-6.68-4.37,6.68H303l6-9.25-5.73-8.49h3.35L311,52.49l4.18-6.38h3.39l-5.8,9,5.91,8.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M337,46.11V66a6.22,6.22,0,0,1-1.77,4.89q-1.77,1.56-5.54,1.56H325V69.85h4.67a4.18,4.18,0,0,0,3-1,4,4,0,0,0,1-3V61.05a6.24,6.24,0,0,1-5.88,3.21,5.94,5.94,0,0,1-4.47-1.64,6.26,6.26,0,0,1-1.6-4.58V50.11a2.53,2.53,0,0,0-.3-1.3,4.86,4.86,0,0,0-1.09-1.15l2.22-2a4.67,4.67,0,0,1,1.94,1.71,5.58,5.58,0,0,1,.55,2.7v7.66a4,4,0,0,0,1,2.85,3.55,3.55,0,0,0,2.69,1,4.5,4.5,0,0,0,3.39-1.41,5.89,5.89,0,0,0,1.59-3.53V46.11Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoonboarding);
export default __webpack_public_path__ + "static/media/LOGO ONBOARDING.e2c3ee0d36197a1d60ded6596cb65850.svg";
export { ForwardRef as ReactComponent };